import BugReportIcon from '@mui/icons-material/BugReport';
import RefreshIcon from '@mui/icons-material/Refresh';
import { Box, Button, Container, Typography } from '@mui/material';

// Catches global errors in the router.
export const RootBoundary = () => {
  return (
    <Container maxWidth='md' sx={{ mt: 8 }}>
      <Box
        sx={{
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
          textAlign: 'center',
          gap: 3,
        }}
      >
        <BugReportIcon sx={{ fontSize: 64, color: 'error.main' }} />

        <Typography variant='h4' gutterBottom>
          Oops! Something went wrong
        </Typography>

        <Typography
          variant='body1'
          sx={{
            color: 'text.secondary',
            mb: 2,
          }}
        >
          We encountered an unexpected error. Please try refreshing the page or
          contact support if the problem persists.
        </Typography>

        <Box
          sx={{
            display: 'flex',
            gap: 2,
            flexWrap: 'wrap',
            justifyContent: 'center',
          }}
        >
          <Button
            variant='contained'
            startIcon={<RefreshIcon />}
            onClick={() => window.location.reload()}
          >
            Try Again
          </Button>
          <Button variant='outlined' onClick={() => window.location.reload()}>
            Reload Page
          </Button>
        </Box>
      </Box>
    </Container>
  );
};
